import client from '@/api/PortalBackendService/_portalBackendServiceClient'
import moment from 'moment'
import {i18n} from '@/locales'
import {Settings as LuxonSettings} from 'luxon'
import json from '@/configuration.json'

/**
 * Returns a maximum of {limit} PaymentLineItems from a specific date on for a specific transitaccount.
 *
 * @param {int} cardId Card ID
 * @param {object} dateTimeFrom The datetime from, when the items have to be returned, MomentJs object
 * @param {object} [dateTimeTo=null] The datetime to, the items have to be returned, MomentJs object. Default now.
 * @param {object} [params={}] Object of additional request parameters:
 * @param {number} [params.limit] The maximum number of items to be returned. 10 by default
 * @param {number} [params.offset] The offset from where the results have to be returned. 0 by default
 * @param {string} [params.organisationName] Name of the PTO ('NS', 'ARRIVA', etc.)
 * @param {string} [params.transportType] '1': Bus, '2': Train, '3': Metro/Underground, '4': Tram, '5': Taxi, '6': Waterborne vehicle, '11': Backoffice/other
 * @param {string} [params.routeNumber] e.g. Bus number, filled if a linenumber is available
 * @param {string} [params.paymentMethod] 1: Visa, 2: EMV, 3: IDEAL, 4: PayPal, 5: ApplePay, 11: Backoffice/other
 * @param {string} [params.tokenId] (Internal)Id of the token used for the trip
 *
 * @returns {Promise<object>} Promise object representing the array of data
 */
function getPaymentsByXtat(cardId, dateTimeFrom, dateTimeTo, params) {
  return new Promise(((resolve, reject) => {
    if (!moment.isMoment(dateTimeFrom)) {
      throw new Error('dateTimeFrom should be a MomentJs object')
    }
    if (!moment.isMoment(dateTimeTo)) {
      dateTimeTo = moment()
    }

    if (typeof params !== 'object') {
      params = {}
    }

    params['dateTimeFrom'] = dateTimeFrom.utc().format()
    params['dateTimeUntil'] = dateTimeTo.utc().format()

    client.get(`/user/card/${cardId}/payments`, {
      params: params
    })
      .then(({data}) => {
        resolve(data)
      })
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  }))
}

function downloadReceipt(srfid, date = '', path = '/user/receipts', windowOpen = false) {
  return new Promise(((resolve, reject) => {
    let params = {}
    params['language'] = LuxonSettings.defaultLocale
    params['srfid'] = srfid.toUpperCase()

    client.get(path, {
      params: params
    })
      .then(({data}) => {
        const downloadLink = document.createElement('a')
        downloadLink.href = `data:application/pdf;base64,${data}`
        downloadLink.download = srfid + date + (json.oct_download_receipt_tooltip ? '_' + i18n.t('cards.payments_history.download_receipt_file_name') : '') + '.pdf'
        downloadLink.click()

        if (windowOpen) {
          let pdfWindow = window.open('')
          if (pdfWindow) {
            // pdfWindow.document.write('<html<head><title>'+ downloadLink.download +'</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>')
            // pdfWindow.document.write('<body><embed width="100%" height="100%" src="data:application/pdf;base64,' + encodeURI(data)+'#toolbar=0&navpanes=0&scrollbar=0"></embed></body></html>')

            pdfWindow.document.write(
              '<iframe width="100%" height="100%" src="data:application/pdf;base64, ' +
              encodeURI(data) + '"></iframe>'
            )
            pdfWindow.document.title = downloadLink.download
            resolve()
          } else {
            resolve()
          }
        } else resolve()
      })
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  }))
}

export default {
  getPaymentsByXtat,
  downloadReceipt
}
